import React from "react";
import { Table } from "antd";
import type { ColumnsType } from "antd/lib/table";

export interface UltimaCompra {
  Fecha: string;
  Prov: string;
  Cantidad: number;
  Frac: number;
  Boni: number;
  Descu: string;
  PVF: string;
  PVP: string;
  Costo: number;
}

interface Props {
  UltimaCompra: UltimaCompra[];
  loader?: boolean;
}

// const UltimasComprasTable: React.FC<Props> = ({ data, loading = false }) => {

const UltimasComprasTable: React.FC<Props> = ({ UltimaCompra, loader }: Props) => {
  const columns: ColumnsType<UltimaCompra> = [
    {
      title: "Fecha",
      dataIndex: "Fecha",
      key: "Fecha",
      width: "20%",
    },
    {
      title: "Provee",
      dataIndex: "Prov",
      key: "Prov",
    },
    {
      title: "Cant",
      dataIndex: "Cantidad",
      key: "Cantidad",
      align: "right",
    },
    {
      title: "Frac",
      dataIndex: "Frac",
      key: "Frac",
      align: "right",
    },
    {
      title: "Boni",
      dataIndex: "Boni",
      key: "Boni",
      align: "right",
    },
    {
      title: "Descu",
      dataIndex: "Descu",
      key: "Descu",
      align: "right",
    },
    {
      title: "PVF",
      dataIndex: "PVF",
      key: "PVF",
      align: "right",
    },
    // {
    //   title: "PVP",
    //   dataIndex: "PVP",
    //   key: "PVP",

    //   align: "right",
    // },
    {
      title: "Costo",
      dataIndex: "Costo",
      key: "Costo",
      align: "right",
    },
  ];

  return (
    <Table
      className='custom-table-visor'
      columns={columns}
      dataSource={UltimaCompra}
      loading={loader}
      scroll={{ x: 100, y: 60 }}
      pagination={false}
      bordered
      size='small'
      title={() => <div style={{ textAlign: "left" }}>Compras</div>}
    />
  );
};

export default UltimasComprasTable;
